<div class="popup-main" [ngClass]="{ opened: opened }">
  <div class="popup-poser">
    <div class="content-box">
      <button class="close" (click)="Close()"></button>
      <ng-content></ng-content>
    </div>
  </div>
</div>
